import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-travel-report',
  templateUrl: './travel-report.component.html',
  styleUrls: ['./travel-report.component.css']
})
export class TravelReportComponent implements OnInit {

  travelsDataSource: MatTableDataSource<any>;
  displayedColumns = ['id', 'description', 'initTime', 'customer'];
  @Input() travels: any;
  constructor() { }

  ngOnInit(): void {
  }

}
